import React from "react";

const Detail = ({ text, label }) => (
    <div>
        <div style={{ display: 'inline-flex' }}>
            <div style={{ fontWeight: 'bold', whiteSpace: 'pre' }}>{label}</div>
            <div>{text}</div>
        </div>
    </div>
)

export default Detail;